import { useState } from "react";

import { BreadcrumbToolbarProvider } from "./breadcrumb-toolbar-context";

import Breadcrumbs, { BreadcrumbsProps } from "@/components/ui/Breadcrumbs";
import { cn } from "@/lib/utils";

interface BreadcrumbsPageWrapperProps extends BreadcrumbsProps {
  children: React.ReactNode;
  className?: string;
  endAdornment?: React.ReactNode;
}

export const PageWrapper = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => <div className={cn("px-8 pt-3", className)}> {children} </div>;

const BreadcrumbsPageWrapper = ({
  children,
  className,
  items,
  showBackButton,
  onBackClick,
  ariaLabel,
  endAdornment,
  ...breadcrumbsProps
}: BreadcrumbsPageWrapperProps) => {
  const [toolbarContainer, setToolbarContainer] = useState<HTMLDivElement | null>(null);
  const hasHeader = (items && items.length > 1) || endAdornment || breadcrumbsProps.entityTitle;

  return (
    <BreadcrumbToolbarProvider value={toolbarContainer}>
      <PageWrapper className={cn("pt-6", className)}>
        {hasHeader && (
          <div className="mb-2 flex min-w-0 items-center justify-between gap-2">
            {items && items.length > 1 ? (
              <div className="min-w-0 flex-1 overflow-hidden">
                <Breadcrumbs
                  items={items}
                  showBackButton={showBackButton}
                  onBackClick={onBackClick}
                  ariaLabel={ariaLabel}
                  {...breadcrumbsProps}
                />
              </div>
            ) : (
              <div className="flex-1" />
            )}
            <div className="flex flex-shrink-0 items-center gap-1">
              <div ref={setToolbarContainer} className="flex items-center gap-1" />
              {endAdornment}
            </div>
          </div>
        )}
        {children}
      </PageWrapper>
    </BreadcrumbToolbarProvider>
  );
};

export default BreadcrumbsPageWrapper;
